import React from "react";
import { ConfirmModalContext } from "./ConfirmProvider";

const useConfirmModal = () => React.useContext(ConfirmModalContext);

export default useConfirmModal;
